import {
  Block,
  Button,
  Card,
  Flex,
  Grid,
  Loadable,
  Text,
} from '@actovos-consulting-group/ui-core';
import axios from 'axios';
import { navigate } from 'gatsby';
import React from 'react';
import { useAsync } from 'react-use';
import useQuery from '../../../../hooks/use-query';

const Pricing = () => {
  const query = useQuery();

  const { value: plans, loading } = useAsync(async () => {
    const { data } = await axios.get(`${process.env.GATSBY_API_URL}/stripe`);
    return data;
  });

  const appID = query.get('appID');
  if (!appID) {
    navigate('/');
    return null;
  }

  return (
    <Block>
      <Loadable loading={loading} minHeight={300}>
        <Grid.Row auto>
          {(plans || []).map(({ title, id, description, price }) => (
            <Grid.Column key={id}>
              <Card>
                <Flex
                  height="100%"
                  flexDirection="column"
                  justifyContent="space-between"
                >
                  <Text textAlign="center" fontSize={30}>
                    {title}
                  </Text>
                  <Text mt={20} textAlign="center" fontSize={40}>
                    ${price}
                  </Text>
                  <Text my={50}>{description}</Text>
                  <form
                    method="post"
                    action={`${process.env.GATSBY_API_URL}/stripe`}
                  >
                    <input type="hidden" value={id} name="priceID" />
                    <input type="hidden" value={appID} name="appID" />
                    <Button type="submit" fullWidth>
                      Buy Now
                    </Button>
                  </form>
                </Flex>
              </Card>
            </Grid.Column>
          ))}
        </Grid.Row>
      </Loadable>
    </Block>
  );
};

export default Pricing;
